import axios from 'axios';

export default axios.create({
     baseURL: 'https://ylight-music-api.vercel.app',
  // baseURL: 'https://ylight.glitch.me',
});
